import { render } from "./ProductsEdit.vue?vue&type=template&id=1bd3bc76"
import script from "./ProductsEdit.vue?vue&type=script&lang=js"
export * from "./ProductsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__